<template>
  <ul :class="[prefix+'-operation', 'list-unstyled']">
    <li>
      <t-button :type="rightButtonType" :disabled="!rightActive" size="sm" @click="$_onLeftButtonClick">
        <template v-if="operations.length <= 0">&lt;</template>
        <template v-else>{{ operations[0] }}</template>
      </t-button>
    </li>
    <li>
      <t-button :type="leftButtonType" :disabled="!leftActive" size="sm" @click="$_onRightButtonClick">
        <template v-if="operations.length <= 0">&gt;</template>
        <template v-else>{{ operations[1] }}</template>
      </t-button>
    </li>
  </ul>
</template>

<script>
import { TButton } from '../button'
import { PREFIX_CLASS } from '@/utils/constants'

export default {
  name: 'TTransferOperation',
  components: {
    TButton
  },
  props: {
    operations: {
      type: Array,
      default() {
        /* istanbul ignore next */
        return []
      }
    },
    size: {
      type: String,
      default: '',
      validator (value) {
        return ['', 'sm'].includes(value)
      }
    }
  },
  data: function () {
    return {
      prefix: PREFIX_CLASS + 'transfer',
      leftActive: false,
      rightActive: false
    }
  },
  computed: {
    leftButtonType () {
      return this.$parent.leftCheckedKeys.length > 0 ? 'primary' : 'secondary'
    },
    rightButtonType () {
      return this.$parent.rightCheckedKeys.length > 0 ? 'primary' : 'secondary'
    }
  },
  methods: {
    $_onLeftButtonClick () {
      this.$parent && this.$parent.moveTo('left')
    },
    $_onRightButtonClick () {
      this.$parent && this.$parent.moveTo('right')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/transfer/operation.vue